const servicioObjetos = {

    asignarAtributosObjeto(event, _this, toUpperCase) {
      let nombrePropiedad = event.target.name;
      let valorPropiedad = event.target.value;
      if (toUpperCase) {
        if (valorPropiedad && typeof valorPropiedad !== 'object')
          valorPropiedad = valorPropiedad.toUpperCase();
      }
      let elementos = nombrePropiedad.split(".");    
      let objeto = _this.state[elementos[0]];
      if (elementos.length > 2) {
        var nombreObjeto = elementos[1];
        var laPropiedad = elementos[2];
        // if (objeto.hasOwnProperty(nombreObjeto)) {
        //   objeto[nombreObjeto] = {};
        // }
        objeto[nombreObjeto][laPropiedad] = valorPropiedad;
      } else {      
        let nombreAtributoObjetoState = elementos[1];
        objeto[nombreAtributoObjetoState] = valorPropiedad;
      }
      _this.setState({ objeto });
    },
  
    esObjetoVacio(objeto) {     
      if (objeto === undefined)
        return true;
        
      if (objeto === null)
        return true;
        
      if (objeto.length > 0)      
        return false;
        
      if (objeto.length === 0)
        return true;
            
      if (objeto === true)
        return false;    
        
      if (Object.keys(objeto).length > 0)
        return false;
      
  
      if (JSON.stringify(objeto) === JSON.stringify({}))
        return true;
        
      for (var key in objeto) {
        if (hasOwnProperty.call(objeto, key))
          return false;              
      }
      if (typeof objeto === 'number')
        return false;
            
      if (JSON.stringify(objeto).length > 0)
          return false; 
      return true;
    },
    eliminarObjetoMapa(arreglo, elemento) {
      const indice = arreglo.indexOf(elemento);
      arreglo.splice(indice, 1);
    },
    obtenerObjetoDeArregloPorPropiedad(arreglo, identificador, valor) {
      for (var i = 0; i < arreglo.length; i++) {
        if (arreglo[i][identificador] === valor) {
          return arreglo[i];        
        }
      }
      return null;
    }
  }
  
  export default servicioObjetos;